import React from 'react'
import PropTypes from 'prop-types'

import { config } from '../../config.js'
import { useAuth } from '../../providers/AuthProvider.js'
import BodyText, { BoldSpan } from '../styles/Text.js'
import ConfirmationTemplate from '../common/ConfirmationTemplate.js'

function BillConfirmation({ secondaryId }) {
  const { authState } = useAuth()
  const showLogo = !authState.accessToken

  return (
    <ConfirmationTemplate title="Payment Complete" bodyText={[]} showLogo={showLogo} showContact={config.showContact}>
      <BodyText>
        Your payment for <BoldSpan>{secondaryId}</BoldSpan> has been accepted. You will receive a receipt to your email.
      </BodyText>
    </ConfirmationTemplate>
  )
}

BillConfirmation.propTypes = {
  secondaryId: PropTypes.string.isRequired
}

export default BillConfirmation
